import React, { useMemo } from 'react';
import SwatchButtonGroup from './SwatchButtonGroup';
import { StyledButtonGroupList } from './SwatchButtonGroupList.style';

export default function SwatchButtonGroupList({
  className,
  options,
  styles,
  onActiveCallback,
  selectedDefault,
  isDisabled,
  disabledOptionName,
}) {
  const activeDefaults = useMemo(() => (
    options.map((option, i) => ({
      name: option.name,
      value: selectedDefault[i],
    }))
  ), [options, selectedDefault]);

  return (
    <StyledButtonGroupList className={className}>
      {options.map((o, i) => {
        let optionClassName = i === options.length - 1 ? 'last' : '';
        if (disabledOptionName && disabledOptionName === o.name) {
          optionClassName += ' hide';
        }

        return (
          <SwatchButtonGroup
            activeDefault={activeDefaults[i]}
            onActiveCallback={onActiveCallback}
            styles={styles}
            option={o}
            className={optionClassName}
            isDisabled={isDisabled}
            key={o.position}
          />
        );
      })}
    </StyledButtonGroupList>
  );
}
